import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, ReactiveFormsModule} from '@angular/forms';
import {TranslationService} from '@emma-labs/shared/angular';
import {ENVIRONMENT, EnvironmentBroker} from '@emma-labs/shared/typescript';
import {CardModule} from 'primeng/card';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {BaseSectionComponent} from '../../base-section/base-section.component';

@Component({
  selector: 'em-proposal-note-section',
  templateUrl: './proposal-note-section.component.html',
  imports: [CardModule, ReactiveFormsModule, InputTextareaModule],
})
export class ProposalNoteSectionComponent extends BaseSectionComponent<FormControl<string | null>, string> {
  constructor(
    readonly translate: TranslationService,
    fb: FormBuilder,
    @Inject(ENVIRONMENT) environment: EnvironmentBroker,
  ) {
    super(environment);
    this.form = fb.control<string | null>(null);
  }
}
